export const ApiConfig = {
  baseUrl: "https://app-xlung-back.xlung.org",
};
